import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { PoaPriceHelper } from '@helpers/poa-price.helper';

@Component({
  selector: 'app-lhcb-coupon-banner',
  templateUrl: './lhcb-coupon-banner.component.html',
  styleUrls: ['./lhcb-coupon-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LhcbCouponBannerComponent {
  private static readonly COPIED_RESET_MS: number = 1500;

  @Input() public couponCode: string | null = null;
  // #13213 — POA price comes from the backend product config; the title line is hidden until it arrives
  @Input() public poaPrice: number | null = null;

  public isCopied: boolean = false;

  public get isPoaPriceLoaded(): boolean {
    return this.poaPrice !== null;
  }

  public get poaPriceDisplay(): string {
    return this.poaPrice === null ? '' : PoaPriceHelper.formatPrice(this.poaPrice);
  }

  private resetTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  public async copyToClipboard(): Promise<void> {
    if (this.couponCode == null || this.couponCode.length === 0) {
      return;
    }
    try {
      await navigator.clipboard.writeText(this.couponCode);
      this.isCopied = true;
      this.cdr.markForCheck();

      if (this.resetTimeoutId !== null) {
        clearTimeout(this.resetTimeoutId);
      }
      this.resetTimeoutId = setTimeout(() => {
        this.isCopied = false;
        this.resetTimeoutId = null;
        this.cdr.markForCheck();
      }, LhcbCouponBannerComponent.COPIED_RESET_MS);
    } catch {
      // clipboard write may fail in restricted contexts (e.g. iframe without permission); silently no-op
    }
  }
}
